import { manualOrderConstants as C } from '../actions/constants';

const init = {
    loading: false,
    creating: false,
    error: null,
    results: [],
    total: 0,
    page: 1,
    hasMore: false,
    lastOrder: null,
};

export default function manualOrder(state = init, action) {
    switch (action.type) {
        case C.SEARCH_REQUEST:
            return { ...state, loading: true, error: null };
        case C.SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                // «Показать ещё» дописывает следующую страницу к уже показанным товарам.
                results: action.append ? [...(state.results || []), ...(action.payload || [])] : action.payload,
                total: Number(action.total ?? (action.payload || []).length),
                page: Number(action.page || 1),
                hasMore: action.hasMore === true,
            };
        case C.SEARCH_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case C.CREATE_REQUEST:
            return { ...state, creating: true, error: null, lastOrder: null };
        case C.CREATE_SUCCESS:
            return { ...state, creating: false, lastOrder: action.payload };
        case C.CREATE_FAILURE:
            return { ...state, creating: false, error: action.payload };

        default:
            return state;
    }
}
